<template>
  <div class="cont">
    <!-- <div class="title" :style="{ backgroundImage: 'url(' + curData.title + ')'}" :class="title_object">
      <div class="title_name" :style="{ backgroundImage: 'url(' + curData.title_text + ')'}" :class="title_name_object"></div>
    </div>  -->
    <div class="clear">
      <el-image style="width: 100%; " v-show="curData.src1" :src="curData.src1" fit="contain"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      id : '' ,
      pageData : {
        328  : {
          name : '328' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/328/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/328/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/328.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/328/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/328/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/328/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/328/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/328/img6.png') ,
        } ,
        DOT4 : {
          name : 'DOT4' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/DOT4/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/DOT4/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img6.png') ,
          src7 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img7.png') ,
          src8 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4/img8.png') ,
        } ,
        DOT4LV : {
          name : 'DOT4LV' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img6.png') ,
          src7 : require('@/assets/image/variousproducts/brakeOilDetail/DOT4LV/img7.png') ,
        } ,
        DOT51 : {
          name : 'DOT51' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/DOT51/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/DOT51/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img6.png') ,
          src7 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img7.png') ,
          src8 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img8.png') ,
        } ,
         DOT51EHV : {
          name : 'DOT51EHV' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/DOT51EHV/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/DOT51EHV/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51EHV.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img6.png') ,
          src7 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img7.png') ,
          src8 : require('@/assets/image/variousproducts/brakeOilDetail/DOT51/img8.png') ,
        } ,
        DOTDUR : {
          name : 'DOTDUR' ,
          title :  require('@/assets/image/variousproducts/brakeOilDetail/DUR/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakeOilDetail/DUR/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/brakeOilDetail/DUR.png') ,
          src2 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img2.png') ,
          src3 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img3.png') ,
          src4 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img4.png') ,
          src5 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img5.png') ,
          src6 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img6.png') ,
          src7 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img7.png') ,
          src8 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img8.png') ,
          src9 : require('@/assets/image/variousproducts/brakeOilDetail/DUR/img9.png') ,
        }
        
      },
      curData : {}
    }
  } ,
  methods: {
    getData () {
      let id = this.id
      this.curData = this.pageData[ id ]
    }
  } ,
  created(){
    this.id =  this.$route.params.id  
    this.getData()
  },
  computed: {
    title_object: function () {
      return {
        "t_328" : this.curData.name == '328' ,
        't_DOT4' : this.curData.name ==  'DOT4' , 
        't_DOT4LV' :  this.curData.name  == 'DOT4LV' ,        
        "t_DOT51" : this.curData.name == 'DOT51' ,
        "t_DOT51EHV" : this.curData.name == 'DOT51EHV' ,
        "t_DUR" : this.curData.name == 'DOTDUR' ,
        
      }
    } ,
    title_name_object : function () {
      return {
        "t_n_328" : this.curData.name == '328' ,
        't_n_DOT4' : this.curData.name ==  'DOT4' ,
        't_n_DOT4LV' :  this.curData.name  == 'DOT4LV' ,
        "t_n_DOT51" : this.curData.name == 'DOT51' ,
        "t_n_DOT51EHV" : this.curData.name == 'DOT51EHV' ,
        "t_n_DUR" : this.curData.name == 'DOTDUR' ,

      }
    } ,
    img1 : function () {
      return {
        "img1_328" : this.curData.name == '328' ,
        'img1_DOT4' : this.curData.name ==  'DOT4' ,
        'img1_DOT4LV' :  this.curData.name  == 'DOT4LV' ,
        "img1_DOT51" : this.curData.name == 'DOT51' ,
        "img1_DOT51EHV" : this.curData.name == 'DOT51EHV' ,
        "img1_DUR" : this.curData.name == 'DOTDUR' ,

      }
    } ,

  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id 
      this.getData()

      // console.log( from )
    }
  }
}
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after { 
  display: block;
  clear: both;
  content: '';
}

.title { 
  position: absolute;
  left: 66px;
  top: -68px;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  font-size:30px 
  color:#fff;
  text-align :center
}
.t_328{
  padding: 28px 36px 22px 43px; 
  width: 170px;
  height: 108px;
}
.t_DOT4{
  padding: 24px 40px 22px 39px; 
  width: 170px;
  height: 108px;
}
.t_DOT4LV{
  padding: 24px 35px 25px 39px; 
  width: 170px;
  height: 108px;
}
.t_DUR {
  padding: 24px 36px 22px 43px; 
  width: 170px;
  height: 108px;
}
.t_DOT51{
  padding: 24px 36px 22px 52px;
  width: 195px;
  height: 108px;
}
.t_DOT51EHV{
  padding: 24px 36px 22px 52px;
  width: 195px;
  height: 108px;
}

.title_name {
  background-repeat: no-repeat;
  background-size: contain;
}
.t_n_328 {
  width: 91px;
  height: 62px;
}
.t_n_DOT4{
  width: 91px;
  height: 62px;
}
.t_n_DOT4LV {
  width: 96px;
  height: 58px;
}
.t_n_DUR {
  width: 91px;
  height: 62px;
}
.t_n_DOT51{
    width: 91px;
  height: 62px;
}
.t_n_DOT51EHV{
    width: 91px;
  height: 62px;
}


.img1_328{
  width: 227px;
}
.img1_DOT4{
  width:287px
}
.img1_DOT4LV{
  width: 233px
}
.img1_DOT51{
  width: 356px
}
.img1_DUR {
  width : 445px
}


</style>